import React from 'react';

// eslint-disable-next-line max-len
const LANGTON_LOGO = '/themes/theme/langton/logo.png';

const LangtonTheme = {
  headerLogo: {
    src: LANGTON_LOGO,
    alt: 'Langton Logo',
    size: 70,
  },
  darkLogo: {
    src: LANGTON_LOGO,
    alt: 'Langton Logo',
    size: 70,
  },
  linkStyle: {
    color: '#FF0000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #FF0000',
    height: 80,
  },
  title: 'Langton',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={LANGTON_LOGO} alt="Langton Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://reports.langtonpr.com',
};

export default LangtonTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/langton.js
 **/